export default __webpack_public_path__ + "static/media/Pembayaran.b8e646b5.png";